document.addEventListener('DOMContentLoaded', function() {
    const button = document.querySelector('.view-all-button_text');
    const listContainer = document.querySelector('.right-details-list-container');
    const listItems = document.querySelectorAll('.right-details-list > li');
    const populatedMetafieldsCount = parseInt(listContainer.dataset.populatedMetafieldsCount, 10);

    const MAX_VISIBLE_ROWS_DESKTOP = 8;

    const calculateHeight = (count, isExpanded) => {
        const rows = Math.ceil(count / 2);
        const maxRows = isExpanded ? rows : MAX_VISIBLE_ROWS_DESKTOP;
        return Math.min(rows, maxRows) * 80;
    };

    const applyHeightAndVisibility = () => {
        const isExpanded = listContainer.classList.contains('expanded');
        if (window.innerWidth > 600) {
            listContainer.style.height = `${calculateHeight(Math.min(populatedMetafieldsCount, 8), isExpanded)}px`;
            listItems.forEach((item, index) => {
                if (!isExpanded && index > 7) {
                    item.style.visibility = 'hidden';
                } else {
                    item.style.visibility = 'visible';
                }
            });
        } else {
            listContainer.style.height = '';
            listItems.forEach((item) => {
                item.style.visibility = 'visible';
            });
        }
    };

    applyHeightAndVisibility();

    const generateSVG = (rotate) => {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="7" viewBox="0 0 9 7" fill="none">
                    <g clip-path="url(#clip0_4033_8284)">
                        <path d="M1.5 2.1001L4.5 5.1001L7.5 2.1001" stroke="black" stroke-width="1.5" transform="rotate(${rotate}, 4.5, 3.5)"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_4033_8284">
                            <rect width="8" height="6" fill="white" transform="translate(0.5 0.600098)"/>
                        </clipPath>
                    </defs>
                </svg>`;
    };

    button.addEventListener('click', function() {
        listContainer.classList.toggle('expanded');
        const isExpanded = listContainer.classList.contains('expanded');
        
        if (isExpanded) {
            button.innerHTML = `View Less ${generateSVG(180)}`;
            listContainer.style.height = `${calculateHeight(populatedMetafieldsCount, isExpanded)}px`;

            listItems.forEach((item) => {
                item.style.visibility = 'visible'; 
                item.style.transition = 'visibility 1s'; 
            });

            if (populatedMetafieldsCount > MAX_VISIBLE_ROWS_DESKTOP && window.innerWidth > 600) {
                listContainer.style.overflowY = 'auto';
            } else {
                listContainer.style.overflowY = 'hidden';
            }


            listContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });

        } else {
            button.innerHTML = `View All ${generateSVG(0)}`;
            listContainer.style.height = `${calculateHeight(Math.min(populatedMetafieldsCount, 8), isExpanded)}px`;
            listContainer.style.overflowY = 'hidden';

            listItems.forEach((item, index) => {
                if (!isExpanded && index > 7) {
                    item.style.visibility = 'hidden';
                    item.style.transition = 'visibility .1s';
                }
            });

            listContainer.scrollTop = 0; 
        }
    });

    window.addEventListener('resize', function() {
        applyHeightAndVisibility();

        const isExpanded = listContainer.classList.contains('expanded');
        if (isExpanded && populatedMetafieldsCount > MAX_VISIBLE_ROWS_DESKTOP && window.innerWidth > 600) {
            listContainer.style.overflowY = 'auto';
        } else {
            listContainer.style.overflowY = 'hidden';
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const readMoreButton = document.querySelector('.read-more-button_text');
    const truncatedDescription = document.querySelector('.truncated-description');
    const fullDescription = document.querySelector('.full-description');
    
    if (readMoreButton && truncatedDescription && fullDescription) {
        readMoreButton.addEventListener('click', function() {
            if (fullDescription.style.display === 'none') {
                fullDescription.style.display = 'block';
                truncatedDescription.style.display = 'none';
                readMoreButton.textContent = 'Read less';
            } else {
                fullDescription.style.display = 'none';
                truncatedDescription.style.display = 'block';
                readMoreButton.textContent = 'Read more';
            }
        });
    }
});
